import { useCallback, useEffect, useState } from 'react';

import { GetDocumentUploadResponse } from '@iwoca/lapi-client/edge';

import { fetchGetDocumentUpload } from '../../../../api/lending/edge';

export function useUploadedDocuments({
  stateKey,
}: {
  stateKey: string | null | undefined;
}) {
  const [uploadedFiles, setUploadedFiles] = useState<
    GetDocumentUploadResponse['data']
  >([]);

  const getUploadedDocuments = useCallback(async () => {
    if (stateKey) {
      try {
        const { data } = await fetchGetDocumentUpload({ stateKey });
        setUploadedFiles(data);
      } catch {}
    }
  }, [stateKey]);

  useEffect(() => {
    void getUploadedDocuments();
  }, [getUploadedDocuments]);

  return {
    getUploadedDocuments,
    hasUploadedFiles: uploadedFiles.length > 0,
    uploadedFiles,
  };
}
